import React, { useCallback } from 'react';
import styles from './style.module.css'



const InfoLoja = (props) => {

	const resolveImage = useCallback(() => {
		let imagem = props.imagem
		return imagem ? `${imagem}` : `assets/sem_imagem.png`
	})


	return (
		<div className={styles['box-loja']}>

			<div className={styles['pic-box-loja']} >
				<img alt="imagem" src={resolveImage()} />
			</div>


			<div style={{ gridArea: "titulo" }}>
				<h1>{props.descricao}</h1>
			</div>


			<div style={{ gridArea: "mesa" }}>
				<div className={styles.wrapperTable}>
					<p id={styles['tableTitle']}>Mesa</p>
					<p id={styles['table']}>{props.mesa}</p>
				</div>
			</div>
		</div>
	);
}





export default InfoLoja;